import { token } from '../store/state';

declare global {
  interface Window {
    API_BASE: string;
  }
}

export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function api<T = unknown>(path: string, opts: RequestInit = {}): Promise<T> {
  const res = await fetch(window.API_BASE + path, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      ...(token.value ? { Authorization: 'Bearer ' + token.value } : {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new ApiError(data?.error || 'Error', res.status);
  }
  return data as T;
}

export async function uploadFile(dataUrl: string): Promise<string> {
  try {
    const res = await api<{ url: string }>('/uploads', {
      method: 'POST',
      body: JSON.stringify({ dataUrl }),
    });
    return res.url;
  } catch {
    return dataUrl;
  }
}
